import { Link, useLocation } from "react-router-dom";

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : isHomePage ? 'bg-transparent' : 'bg-white shadow-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link
              to="/"
              className="text-2xl font-bold tracking-tight cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Shock Growth Partners
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            {isHomePage ? (
              <>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Home
                </button>
                <button
                  onClick={() => scrollToSection('affiliation')}
                  className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Affiliation
                </button>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Services
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/"
                  className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Home
                </Link>
              </>
            )}
            <Link
              to="/articles"
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Articles
            </Link>
            {isHomePage ? (
              <button
                onClick={() => scrollToSection('contact')}
                className="px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Contact Us
              </button>
            ) : (
              <Link
                to="/#contact"
                className="px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Contact Us
              </Link>
            )}
          </div>

          <button className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}